import React from 'react';
import { Provider } from 'react-redux';
import { __ } from 'i18n/index';
import store from 'react/redux/store/store';
import { declickables } from 'components/Declickables';
import { LadderPopup } from 'components/LadderPopup';
import { matchSearchListManager } from 'components/MatchSearchListManager';
import { ChatActions } from 'components/ChatActions';
import PostGroup from 'models/PostGroup';
import PostManagerComponent from 'react/posts/PostManagerComponent';
import { SubscribeButtonComponent } from 'react/profile/SubscribeButtonComponent';
import openDirectMessageHere from 'react/dock/chat/openDirectMessageHere';
import { MatchHistory } from 'components/MatchHistory';
import { Dashboard } from 'components/Dashboard';
import { Request } from 'components/Request';
import { isNetplayPageActive } from 'react/netplay/netplayPageState';
import { assignPage, openPage } from 'navigation/pageLocation';

// Click handlers for the profile card, carried over from the old card popup.

export function openDirectMessage(player, closePopup) {
	if(openDirectMessageHere(player)) {
		closePopup();
	}
	else {
		assignPage(`${siteUrl}/netplay?send_message=${player.id}`);
	}
}

export function openMatchHistory(player, closePopup) {
	closePopup();
	declickables.closeDeclickables();
	MatchHistory.retrieveHistory({ player });
}

// Your matches against this player.
export function openHistoryWithYou(player, closePopup) {
	closePopup();
	MatchHistory.retrieveHistory({ player: myUser, againstPlayer: player });
}

export function openProfilePage(player) {
	if(isNetplayPageActive()) {
		openPage(player.getProfileUrl(), '_blank');
	}
	else {
		assignPage(player.getProfileUrl());
	}
}

export function editStatusMessage() {
	declickables.closeDeclickables();
	const popupContent = $('.popups .away_message_popup').clone();
	const input = popupContent.find('[name=away_message]');
	input.text(myUser.away_message === null ? '' : myUser.away_message);
	input.elastic();
	const popup = Dashboard.ladderPopup(popupContent, __('Set Your Status Message'), {
		buttons: [
			{
				text: __('Close'),
				dismiss: true
			},
			{
				text: __('Update'),
				dismiss: false,
				click: (openPopup) => {
					const message = input.val();
					popupContent.find('[name=away_message]').val(message);
					Request.send({ away_message: message }, 'change_wants_to_play', () => {});
					openPopup.dismiss(__('Changes Saved!'));
				}
			}
		]
	});
	popup.onOpen.then(() => {
		input.trigger('keyup');
	});
}

export function openNotes(player, closePopup) {
	const popup = LadderPopup.create(null, __('Private Notes on %s', player.isMe() ? __('Yourself?!') : player.username)).showLoader();
	declickables.closeDeclickables();
	closePopup();
	Request.apiv1Get('player/notes', { player_id: player.id })
		.then((response) => {
			popup.updateContent(
				<div className='notes_content'>
					<Provider store={store}>
						<PostManagerComponent
							usesQuickReply={false}
							postGroup={PostGroup.create({ topics: response.topics })}
							inputKey={response.key}
							inputValue={String(response.value)}
						/>
					</Provider>
				</div>
			);
		})
		.catch(Request.generalJsonError);
}

// Blocking asks first; unblocking doesn't.
export function toggleBlock(player, { ignorePlayer, unignorePlayer, closePopup }) {
	if(player.isIgnored()) {
		unignorePlayer(player);
		return;
	}
	closePopup();
	LadderPopup.create(__('Block Match Requests, Direct Messages, and Chat Messages'), __('Block %s', player.username), {
		buttons: [
			{ text: __('Nevermind'), dismiss: true },
			{ text: __('Yes!'), dismiss: true, click: () => ignorePlayer(player) },
		]
	});
}

export function reportToMods(player, { reportPlayer, chatRoomId }) {
	reportPlayer(player, { player_id: player.id, chat_room_id: chatRoomId });
}

export function openGiftSubscription(player, closePopup) {
	closePopup();
	LadderPopup.create(
		<div className='profile-card-gift'><Provider store={store}><SubscribeButtonComponent player={player} /></Provider></div>,
		__('Gift %s a subscription', player.username)
	);
}

export function isInDoublesMatch() {
	const currentMatch = matchSearchListManager.getCurrentMatch();
	return !!currentMatch && currentMatch.isDoubles();
}

export function inviteToDoublesMatch(player) {
	const currentMatch = matchSearchListManager.getCurrentMatch();
	if(!currentMatch) {
		return;
	}
	const showInviteError = (response) => {
		if(response && response.invite && response.invite.error) {
			ChatActions.inviteErrorMessageGenerator(player.id, response.invite, matchSearchListManager.getCurrentMatch());
		}
	};
	Request.post(`${siteUrl}/chats/invite_player`, { player_id: player.id, match_id: currentMatch.id })
		.then(showInviteError)
		.catch((error) => showInviteError(error.responseJSON));
}
